module.exports = __webpack_public_path__ + "img/ic-new-btn-arrow-right.ef0b5928.svg";